import React, { Component, ReactElement } from 'react'
import { CommonFormContextProvider } from '../../React/Common/Contexts/CommonFormContext'
import { UserPresencePage } from '../../React/TeamsPresence/Main/UserPresencePage'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'

@Route(RouteID.PRESENCE)
export class Presence extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.PRESENCE}>
                <CommonFormContextProvider>
                    <UserPresencePage isDarkModeSwitch={false} />
                </CommonFormContextProvider>
            </RouteGuard>
        )
    }
}
